//to show duration in string format on collection
import { utility } from "../../../utility/utilityProvider";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { PlanningHelper } from "../../../../modules/Planning/helper/PlanningHelper";

export const TimeCell = (props) => {


  let mainTimeZone = PlanningHelper.getMainTimeZone([props.channel]);
  let additionalTimeZone = PlanningHelper.getAdditionalTimeZone([props.channel]);

  const field = props.field || "";
  let value = '';

  if (field.includes('.')) {
    //For field value coming as example :- MediaCategory.Duration
    let keys = field.split('.');
    value = props.dataItem[keys[0]] ?
      props.dataItem[keys[0]][keys[1]] ? utility.convertMilisecondsToStringWithFrames(props.dataItem[keys[0]][keys[1]]) : ''
      : '';
  } else {
    value = utility.convertMilisecondsToStringWithFrames(props.dataItem[field]);
  }

  // schedulemaingrid
  if (props.entityName && props.entityName == "schedulemaingrid" && (field == "SlotDateTime" || field == "EndSlotDateTime")) {

    //HANDLE SLOT DATE TIME FOR ADDITIONAL TIMEZONE
    switch (props.label) {
      case "GMT Date Time":

        value = utility.convertMilisecondsToDateTimeString(props.dataItem[field]);

        break;
      case "Additional TimeZone":


        value = additionalTimeZone.EnableAdditionalTimeZone ?
          utility.getTimeByTimeZone(
            props.dataItem[field],
            additionalTimeZone?.AdditionalTimeZone?.IsNegativeOffset,
            additionalTimeZone?.AdditionalTimeZone?.Offset,
            null,
            true
          ) :
          utility.convertMilisecondsToStringWithFrames(props.dataItem[field]);


        break;
      case "Time":
      case "End Time":

        value = utility.getTimeByTimeZone(
          props.dataItem[field],
          mainTimeZone?.IsNegativeOffset,
          mainTimeZone?.Offset,
          null,
          true
        )
        // utility.convertMilisecondsToStringWithFrames(props.dataItem[field]);

        break;

      default:
        value = utility.convertMilisecondsToStringWithFrames(props.dataItem[field]);
        break;
    }
  }

  const getSafeValue = (val) => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'number' && isNaN(val)) return '';
    if (typeof val === 'string' && val.includes('NaN')) return '';
    return val;
  };

  return <td
    colSpan={props.colSpan}
    role={"gridcell"}
    aria-colindex={props.ariaColumnIndex}
    aria-selected={props.isSelected}
    {...useTableKeyboardNavigation(props.id)}
    //BY COMMENTING WITH LINE FOR ONCLICK EVENT SELECTION FOR GRID BY CLICKING TIME CELL IS NOT WORKING
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
    }}
    // style={{textAlign : 'center'}}
    style={props.style}
  >
    {getSafeValue(value)}
  </td>;
};

export const TimeHyperLinkCell = (props) => {

  const field = props.field || "";
  let value = ''

  if (field.includes('.')) {
    //For field value coming as example :- MediaCategory.Duration
    let keys = field.split('.');
    value = props.dataItem[keys[0]] ?
      props.dataItem[keys[0]][keys[1]] ? utility.convertMilisecondsToStringWithFrames(props.dataItem[keys[0]][keys[1]]) : ''
      : '';
  } else {
    value = utility.convertMilisecondsToStringWithFrames(props.dataItem[field]);
  }

  const goToSchedule = (e) => {
    console.log(props.dataItem)
    props.onClick(props.dataItem)
  }

  return <td
    onClick={goToSchedule}
    colSpan={props.colSpan}
    role={"gridcell"}
    aria-colindex={props.ariaColumnIndex}
    aria-selected={props.isSelected}
    {...useTableKeyboardNavigation(props.id)}
    // style={{textAlign : 'center'}}
    style={props.style}
    className={"timecell"}
  >
    {value}
  </td>;
};

export const ShortTimeCell = (props) => {

  const field = props.field || "";
  var value = ''

  if (field.includes('.')) {
    //For field value coming as example :- MediaCategory.Duration
    var keys = field.split('.');
    value = props.dataItem[keys[0]] ?
      props.dataItem[keys[0]][keys[1]] ? utility.convertMilisecondsToShortTimeString(props.dataItem[keys[0]][keys[1]]) : ''
      : '';
  } else {
    value = utility.convertMilisecondsToShortTimeString(props.dataItem[field]);
  }

  // const value = moment(props.dataItem[field]).utc().format('DD-MMM-YYYY');

  return <td
    colSpan={props.colSpan}
    role={"gridcell"}
    aria-colindex={props.ariaColumnIndex}
    aria-selected={props.isSelected}
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
    }}
    {...useTableKeyboardNavigation(props.id)}
    // style={{textAlign : 'center'}}
    style={props.style}
  >
    {value}
  </td>;
};

export const TimeCellWithOutFrames = (props) => {

  const field = props.field || "";
  let value = '';

  if (field.includes('.')) {
    //For field value coming as example :- MediaCategory.Duration
    let keys = field.split('.');
    value = props.dataItem[keys[0]] ?
      props.dataItem[keys[0]][keys[1]] ? utility.convertMilisecondsToStringWithFrames(props.dataItem[keys[0]][keys[1]], false) : ''
      : '';
  } else {
    value = props.dataItem[field] ? utility.convertMilisecondsToStringWithFrames(props.dataItem[field], false) : "";
  }

  return <td
    colSpan={props.colSpan}
    role={"gridcell"}
    aria-colindex={props.ariaColumnIndex}
    aria-selected={props.isSelected}
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
    }}
    {...useTableKeyboardNavigation(props.id)}
    // style={{textAlign : 'center'}}
    style={props.style}
  >
    {value}
  </td>;
};